export class MarcheResponsable {
  constructor(
    public uuid: string,
    public matricule: string,
    public nom?: string,
    public prenom?: string
  ) {}

  static adapt(item: any): MarcheResponsable {
    return new MarcheResponsable(item.uuid, item.matricule, item.nom, item.prenom);
  }
}
